import { I18nLookup } from './languageUtils';

/**
 * @description This function will add the suffix to the final characters but preserve the _jsx ending
 * needed to render FormattedJSXMessages properly
 *
 * foo.bar => foo.barCP
 * foo.bar_jsx => foo.barCP_jsx
 * foo.bar_foo => foo.bar_fooCP
 *
 * ```ts
 * const originalKey = 'original.key';
 * const newKey = getCopyChangeKey(originalKey, 'New') // 'original.keyNew'
 * const result = I18nLookup(newKey) ? newKey : originalKey; // I18nLookup is recommended
 * ```
 */
export function getCopyChangeKey(key, suffix) {
  return key.replace(/(_jsx)?$/, `${suffix}$1`);
}
export function getPaymentsCopyUpdateCopyChangeKey(key) {
  const newKey = getCopyChangeKey(key, 'PaymentsCopyUpdate');
  return I18nLookup(newKey) ? newKey : key;
}
export function getRevOsRenameCopyChangeKey(key, isRevOsRenamed) {
  if (!isRevOsRenamed) {
    return key;
  }
  const newKey = getCopyChangeKey(key, 'RevOsRename');
  return I18nLookup(newKey) ? newKey : key;
}